import { render, staticRenderFns } from "./ConfigForm.vue?vue&type=template&id=cce47770&scoped=true&"
import script from "./ConfigForm.vue?vue&type=script&lang=js&"
export * from "./ConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce47770",
  null
  
)

export default component.exports